import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import cn from 'classnames';

import { Pagination, Table } from 'antd';

import * as actions from '../../actions';

import s from './styles.less';

const propTypes = {
  handlePageChange: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  plans: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
  currentPage: PropTypes.number,
  perPage: PropTypes.number,
};
const defaultProps = {
  plans: [],
  total: 0,
  currentPage: 1,
  perPage: 10,
};

const PlansTable = ({
  plans,
  total,
  columns,
  currentPage,
  perPage,
  handlePageChange,
}) => (
  <Fragment>
    <Table
      rowKey="id"
      columns={columns}
      dataSource={plans}
      pagination={false}
      rowClassName={({ PlanCancellation }) =>
        cn({
          [s.cancelled]:
            PlanCancellation &&
            PlanCancellation.isDirectDebitCancelled &&
            PlanCancellation.isRefunded,
        })
      }
    />
    {total !== 0 && (
      <div className={s.pagination}>
        <Pagination
          onChange={handlePageChange}
          total={total}
          current={currentPage}
          perPage={perPage}
        />
      </div>
    )}
  </Fragment>
);

PlansTable.propTypes = propTypes;
PlansTable.defaultProps = defaultProps;

const mapStateToProps = ({ admin }) => ({
  plans: admin.plans,
  currentPage: admin.plansPagination.page,
  perPage: admin.plansPagination.perPage,
  total: admin.plansTotalCount,
});

export default compose(
  connect(
    mapStateToProps,
    {
      changePlansPage: actions.changePlansPage,
      fetchPlans: actions.fetchPlans,
    },
  ),
  withProps(({ changePlansPage, fetchPlans }) => ({
    handlePageChange: currentPage => {
      changePlansPage(currentPage);
      fetchPlans();
    },
  })),
)(PlansTable);
